export default "__VITE_ASSET__AJ03NIR2__"